import { Fragment, type ReactNode } from 'react';
import { messageTemplate } from '../services/language-manager';
import { isolate } from './translate';

/**
 * One catalog sentence with placeholders. A string value is isolated.
 * A React node (a link, bold, or `<code>`) is inserted as given, so the
 * translator controls where it sits.
 */
export function RichText({
  k,
  values,
}: {
  k: string;
  values: Record<string, ReactNode>;
}) {
  const template = messageTemplate(k);
  const nodes: ReactNode[] = [];
  const re = /\{(\w+)\}/g;
  let last = 0;
  let match: RegExpExecArray | null;
  let index = 0;
  while ((match = re.exec(template)) !== null) {
    if (match.index > last) nodes.push(template.slice(last, match.index));
    const name = match[1];
    const value = values[name];
    if (value === undefined) {
      nodes.push(match[0]);
    } else if (typeof value === 'string' || typeof value === 'number') {
      nodes.push(isolate(String(value)));
    } else {
      nodes.push(<Fragment key={index}>{value}</Fragment>);
    }
    index += 1;
    last = match.index + match[0].length;
  }
  if (last < template.length) nodes.push(template.slice(last));
  return <>{nodes}</>;
}
